/** Thrown by the external-chat query/mutation hooks when a service returns a
 *  `detail` string. Services resolve rather than reject on API errors, but
 *  TanStack needs a rejection to mark the query/mutation failed. The distinct
 *  type lets callers tell an expected, already-reported API refusal (surface
 *  `message` to the user) apart from an unexpected throw (report to Sentry).
 *  `apiRequest` has already sent the underlying HTTP failure to Sentry. */
export class ExternalChatApiError extends Error {
  constructor(detail: string) {
    super(detail);
    this.name = 'ExternalChatApiError';
  }
}

export const unwrap = <T>(result: { data?: T; detail?: string }): T => {
  if (result.detail) throw new ExternalChatApiError(result.detail);
  if (result.data === undefined) {
    throw new Error('External chat API returned no data');
  }
  return result.data;
};
